module.exports = __webpack_public_path__ + "img/for-students-bg.a8c98ae4.png";